// import { Column } from "devextreme-react/data-grid";
// import DateTimePicker from "../../components/custom/DateTime";
// import { Formik } from "formik";
import { Grid, Box } from "@mui/material";
import Header from "../../components/custom/Header";
// import Search from "../../components/custom/Search";
// import Table from "../../components/custom/Table/DataGrid";
import { styled } from "@mui/system";
import DataGrid2 from "../../components/custom/Table2/DataGrid2";
import {
  exportFulfilments,
  getFulfilments,
  updateFulfilments,
} from "../../services/fullfilmentsService";
import { Typography } from "@mui/material";
import { format } from "../../utils/fn-utils";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../../components/custom/PrimaryButton";
import { useEffect, useState } from "react";
import Dialog from "../../components/custom/Dialog";
import { GENERAL_ERROR } from "../../constants/errorConstants";
import { getDashboardInfo } from "../../services/dashBoardServices";

const StyledContainer = styled(Grid)`
  width: 100%;
  height: 100%;
`;
const Container = styled(Box)`
  width: auto;
`;

const DateText = styled(Typography)`
  font-size: 0.625rem;
`;

const Fulfilments = () => {
  const columns = [
    { key: "title", dataField: "title", caption: "Title" },
    { key: "identifier", dataField: "identifier", caption: "ISBN" },
    { key: "name", dataField: "name", caption: "Distributor name" },
    // {
    //   key: "transid",
    //   dataField: "transid",
    //   caption: "Transaction id",
    // },
  ];
  const toolbarOptions = {
    bulk: {
      show: false,
      request: null,
    },
    export: {
      show: true,
      request: exportFulfilments,
    },
  };
  const [message, setMessage] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [date, setDate] = useState(null);
  const [totalNumber, setTotalNumber] = useState("");
  const [remainingNumber, setRemainingNumber] = useState("");
  const { locale, t } = useTranslation();
  // sets the date from sessionStorage
  const lastFulfilmentUpdate = () => {
    try {
      const date = JSON.parse(
        window.sessionStorage.getItem("lastFulfillmentRun")
      );
      setDate(date);
    } catch (error) {
      setDate();
    }
  };

  // updates fulfilments last date
  const fulfilemntsUpdate = async () => {
    try {
      const res = await updateFulfilments();
      if (res?.successUpdate) {
        window.sessionStorage.setItem(
          "lastFulfillmentRun",
          JSON.stringify(res?.lastFulfillmentRun)
        );
        setDate(res?.lastFulfillmentRun);
        if (date) {
          setMessage(res?.message);
          setIsDialogOpen(true);
        }
        fetchDashboardInfo();
      } else {
        setDate(res?.lastFulfillmentRun);
        if (date) {
          setMessage(res?.message);
          setIsDialogOpen(true);
        }
      }
    } catch (error) {
      setMessage(t(GENERAL_ERROR));
      setIsDialogOpen(true);
    }
  };

  const fetchDashboardInfo = async () => {
    try {
      const res = await getDashboardInfo();
      setTotalNumber(res?.bookFulfillments);
      setRemainingNumber(res?.totalFulfillments);
      setDate(res?.lastFulfillmentRun);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    lastFulfilmentUpdate();
    fetchDashboardInfo();
    // fulfilemntsUpdate();
  }, []);

  return (
    <>
      <StyledContainer sx={{ p: { xs: 2, md: 10 } }}>
        <Header
          name="Fulfillments"
          productShow={true}
          totalNumber={totalNumber}
          remainingNumber={remainingNumber}
          quantityFrom={"Total number of used fulifllments"}
          quantityTo={"Total number of remaining book fulifllments"}
        />
        <Grid item container direction={"row"} alignItems="center" spacing={6}>
          <Grid item container alignItems="baseline">
            <Typography variant="caption">Last update: </Typography>
            {date ? (
              <DateText marginLeft={[2, 2, 2, 2]}>
                {format(new Date(date), "EEEE dd/MM HH:mm", locale)}
              </DateText>
            ) : (
              <Typography variant="caption" marginLeft={[2, 2, 2, 2]}>
                -
              </Typography>
            )}
          </Grid>
          <Grid item>
            <PrimaryButton
              sx={{ fontSize: [7, 9] }}
              onClick={fulfilemntsUpdate}
            >
              {t("Refresh")}
            </PrimaryButton>
          </Grid>
        </Grid>
        <Container>
          <DataGrid2
            id={"fulfillmentsAll"}
            filename="fulfillments"
            cols={columns}
            getAll={getFulfilments}
            toolbarOptions={toolbarOptions}
          />
        </Container>
        <Dialog
          onClose={() => {
            setIsDialogOpen(false);
            setMessage("");
          }}
          action={() => {
            setIsDialogOpen(false);
            setMessage("");
          }}
          open={isDialogOpen}
        >
          {message}
        </Dialog>
      </StyledContainer>
    </>
  );
};

export default Fulfilments;
